import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import ReactHtmlParser from 'react-html-parser'
import DomPurify from 'dompurify'
const InfoBoxWithIcon = ({
    message,
    iconName,
    iconStyles = {},
    messageStyles = {},
    iconAreaStyles = {},
    rootStyles = {},
}) => {
    return (
        <Box
            sx={{
                border: 'solid 1px #ebebed',
                boxShadow: ' 0 0.4rem 0.6rem -0.2rem rgba(0, 0, 0, 0.1)',
                borderRadius: '0.5rem',
                display: 'inline-flex',
                alignItems: 'center',
                minHeight: '4.8rem',
                background: '#fff',
                overflow: 'hidden',
                ...rootStyles,
            }}
        >
            <Box
                sx={{
                    background: '#8b909a',
                    width: '4.8rem',
                    padding: '1rem',
                    paddingTop: '1.7rem',
                    display: 'flex',
                    justifyContent: 'center',
                    minHeight: '100%',
                    alignSelf: 'stretch',
                    ...iconAreaStyles,

                    '& svg': {
                        width: '2.4rem !important',
                        height: '2.4rem !important',
                        color: 'white',
                        ...iconStyles,
                        '& path': {
                            fill: iconStyles?.color || '#fff',
                        },
                    },
                }}
            >
                <Icon name={iconName} />
            </Box>
            <Box
                sx={{
                    padding: '1.6rem',
                    color: '#5d6870',
                    ...messageStyles,
                }}
            >
                {ReactHtmlParser(
                    DomPurify.sanitize(message),
                )}

            </Box>
        </Box>
    )
}

export default InfoBoxWithIcon
